import React, { useState } from 'react';
import './welcome-menu.scss';
import { JTBD_SVGS } from '../../../../assets';
import ZoButton from '@zonofi/zo-components/input/zo-button/zo-button';
import {
  dispatch,
  updateShowGetOnWhatsappStrip,
} from '@zonofi/seller-rtk-store';

interface WelcomeMenuProps {
  onClose: () => void;
  onMenuItemClick: (quickReply: string) => void;
  onSendClick: () => void;
  quickReply: string;
}

export const WelcomeMenu: React.FC<WelcomeMenuProps> = ({
  onClose,
  onMenuItemClick,
  onSendClick,
  quickReply,
}) => {
  const menuOptions: {
    title: string;
    description: string;
  }[] = [
    {
      title: 'View catalogue',
      description: 'Our latest product catalogue & offers',
    },
    {
      title: 'View outstanding',
      description: 'The outstanding amount as per our records',
    },
    {
      title: 'Get latest invoice',
      description: 'View your most recent invoice',
    },
    {
      title: 'Latest campaign',
      description: 'View your most recent invoice',
    },
    {
      title: 'Switch language',
      description: 'Select your preferred language for a better experience',
    },
  ];
  const [selectedIndex, setSelectedIndex] = useState<number>(-1);

  return (
    <div className="welcome-menu">
      <img
        src={JTBD_SVGS.CloseGreyIcon}
        alt=""
        width={24}
        height={24}
        className="welcome-menu-close"
        onClick={onClose}
      />
      <div className="welcome-menu-header">
        <span className="welcome-menu-header-text tertiary-font-medium">
          Menu
        </span>
      </div>
      <div className="welcome-menu-body">
        <div className="welcome-menu-body-seperator" />
        {menuOptions?.map((item, index) => {
          return (
            <div
              className="welcome-menu-body-item"
              onClick={() => {
                setSelectedIndex(index);
                onMenuItemClick(item?.title);
              }}
            >
              <div className="welcome-menu-body-item-container">
                <div className="welcome-menu-body-item-content">
                  <span className="welcome-menu-body-item-content-title tertiary-font-regular">
                    {item?.title}
                  </span>
                  <span className="welcome-menu-body-item-content-description tertiary-font-regular">
                    {item?.description}
                  </span>
                </div>
                {selectedIndex === index && (
                  <img
                    src={JTBD_SVGS.CheckGreenIcon}
                    alt=""
                    width={24}
                    height={24}
                  />
                )}
              </div>
              <div className="welcome-menu-body-seperator" />
            </div>
          );
        })}
      </div>
      <div className="welcome-menu-footer">
        {selectedIndex < 0 && (
          <div className="welcome-menu-footer-text tertiary-font-regular">
            Tap an item to select it
          </div>
        )}
        {selectedIndex >= 0 && (
          <ZoButton
            onClick={() => {
              onSendClick();
              if (quickReply === 'View catalogue') {
                dispatch(updateShowGetOnWhatsappStrip(true));
              }
            }}
            label={'Send'}
            className="welcome-menu-footer-btn"
          />
        )}
      </div>
    </div>
  );
};
